import type { DecoratedNote } from '@witmetrics/utils';
import BlockHeader from '../BlockHeader';

export type NoteBlockHeaderProps = {
  editable?: boolean;
  note: DecoratedNote;
  onEdit: () => void;
  onDelete: () => void;
};

export default function NoteBlockHeader({
  editable,
  note,
  onEdit,
  onDelete,
}: NoteBlockHeaderProps) {
  return (
    <BlockHeader
      editable={editable}
      createdBy={note.createdBy}
      createdAt={note.createdAt}
      onEdit={onEdit}
      onDelete={onDelete}
    />
  );
}
